import { useQuery } from "@tanstack/react-query";

import { pessoaService } from "@/services/api/PessoaService";
import { PessoaCargoResumoDTO } from "@/types/pessoa-acesso.type";

export function usePessoaResumoCargos() {
  const { data, isLoading } = useQuery<PessoaCargoResumoDTO[]>({
    queryKey: ["pessoa-resumo-cargos"],
    queryFn: () => pessoaService.getResumoCargos(),
  });

  return { cargos: data ?? [], loading: isLoading };
}
